// List of known disposable/temporary email domains
// These domains are commonly used for spam and fake accounts
export const BLOCKED_EMAIL_DOMAINS = [
  // Popular temporary email services
  '10minutemail.com',
  '10minutemail.net',
  '10minutemail.org',
  '10minmail.com',
  '20minutemail.com',
  '30minutemail.com',
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'guerrillamail.de',
  'guerrillamail.info',
  'sharklasers.com',
  'grr.la',
  'guerrillamailblock.com',
  'tempmail.com',
  'tempmail.net',
  'temp-mail.org',
  'temp-mail.io',
  'temp-mail.ru',
  'tempmailo.com',
  'tempr.email',
  'tempail.com',
  'throwaway.email',
  'throwawaymail.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailinator2.com',
  'mailinater.com',
  'maildrop.cc',
  'mailnesia.com',
  'mailcatch.com',
  'mailsac.com',
  'mailslurp.com',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'cool.fr.nf',
  'jetable.fr.nf',
  'nospam.ze.tc',
  'nomail.xl.cx',
  'mega.zik.dj',
  'speed.1s.fr',
  'courriel.fr.nf',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'fakeinbox.com',
  'fakemailgenerator.com',
  'fakemail.net',
  'fakemailgenerator.net',
  'dispostable.com',
  'disposableemailaddresses.com',
  'disposableinbox.com',
  'disposeamail.com',
  'spamgourmet.com',
  'spamspot.com',
  'spam4.me',
  'spamfree24.org',
  'spamherelots.com',
  'spamtroll.net',
  'trashmail.com',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashemail.de',
  'trashmailer.com',
  'trashymail.com',
  'getnada.com',
  'getairmail.com',
  'emailondeck.com',
  'mohmal.com',
  'mohmal.im',
  'mohmal.tech',
  'tempinbox.com',
  'tempmailaddress.com',
  'tmpmail.org',
  'tmpmail.net',
  'crazymailing.com',
  'mintemail.com',
  'mintmail.com',
  'anonymbox.com',
  'anonymousemail.us',
  'anonymousspeech.com',
  'anonbox.net',
  'dropmail.me',
  'emailfake.com',
  'emaillime.com',
  'emailsensei.com',
  'emailtemporario.com.br',
  'emailwarden.com',
  'e4ward.com',
  'einrot.com',
  'einstant.com',
  'fiifke.de',
  'filzmail.com',
  'fixmail.tk',
  'fleckens.hu',
  'flyspam.com',
  'freemail.ms',
  'freundin.ru',
  'garliclife.com',
  'geronra.com',
  'gishpuppy.com',
  'girlsundertheinfluence.com',
  'gowikibooks.com',
  'gowikicampus.com',
  'gowikicars.com',
  'gowikifilms.com',
  'gowikimusic.com',
  'gowikinetwork.com',
  'gowikitravel.com',
  'gowikitv.com',
  'haltospam.com',
  'hmamail.com',
  'hochsitze.com',
  'hooohush.net',
  'hulapla.de',
  'humaility.com',
  'ieatspam.eu',
  'ieatspam.info',
  'ieh-mail.de',
  'imails.info',
  'imgof.com',
  'imgv.de',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'infocom.zp.ua',
  'inoutmail.de',
  'inoutmail.eu',
  'inoutmail.info',
  'inoutmail.net',
  'insorg-mail.info',
  'instantemailaddress.com',
  'ipoo.org',
  'irish2me.com',
  'jetable.com',
  'jetable.net',
  'jetable.org',
  'jsrsolutions.com',
  'jourrapide.com',
  'junk1.com',
  'kasmail.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'kir.ch.tc',
  'klassmaster.com',
  'klassmaster.net',
  'klzlv.com',
  'kostenlosemailadresse.de',
  'kulturbetrieb.info',
  'kurzepost.de',
  'lawlita.com',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'lol.ovpn.to',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lovemeleaveme.com',
  'maboard.com',
  'mail-hierarchie.net',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail.zp.ua',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbidon.com',
  'mailbiz.biz',
  'mailblocks.com',
  'mailbucket.org',
  'mailcat.biz',
  'mailcheap.co',
  'maileater.com',
  'mailexpire.com',
  'mailfa.tk',
  'mailfreeonline.com',
  'mailfree.ml',
  'mailguard.me',
  'mailhub.pw',
  'mailin8r.com',
  'mailinblack.com',
  'mailismagic.com',
  'mailjunk.gq',
  'mailjunk.ml',
  'mailjunk.cf',
  'mailmate.com',
  'mailme.gq',
  'mailme.ir',
  'mailme.lv',
  'mailme24.com',
  'mailmetrash.com',
  'mailmoat.com',
  'mailnator.com',
  'mailnull.com',
  'mailpick.biz',
  'mailproxsy.com',
  'mailsack.com',
  'mailscrap.com',
  'mailseal.de',
  'mailshell.com',
  'mailshuttle.com',
  'mailsiphon.com',
  'mailtemp.info',
  'mailtothis.com',
  'mailzilla.com',
  'mailzilla.org',
  'makemetheking.com',
  'mbx.cc',
  'mega.zik.dj',
  'meinspamschutz.de',
  'meltmail.com',
  'messagebeamer.de',
  'mezimages.net',
  'mierdamail.com',
  'migmail.pl',
  'migumail.com',
  'mjukgansen.nu',
  'moakt.com',
  'mobi.web.id',
  'mobileninja.co.uk',
  'mockmyid.com',
  'momentmail.com',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'monumentmail.com',
  'msgos.com',
  'mspeciosa.com',
  'mswork.net',
  'mt2009.com',
  'mt2014.com',
  'mylittleponyporn.mobi',
  'myphantomemail.com',
  'myspaceinc.com',
  'myspaceinc.net',
  'myspacepimpedup.com',
  'mytempemail.com',
  'mytempmail.com',
  'mytrashmail.com',
  'neomailbox.com',
  'nepwk.com',
  'nervmich.net',
  'nervtmansen.net',
  'netmails.com',
  'netmails.net',
  'netzidiot.de',
  'neverbox.com',
  'nice-4u.com',
  'nigge.rs',
  'nincsmail.hu',
  'nmail.cf',
  'nobulk.com',
  'noclickemail.com',
  'nogmailspam.info',
  'nomail.xl.cx',
  'nomail2me.com',
  'nomorespamemails.com',
  'nospam.ze.tc',
  'nospam4.us',
  'nospamfor.us',
  'nospammail.net',
  'nospamthanks.info',
  'notmailinator.com',
  'nowmymail.com',
  'nurfuerspam.de',
  'nus.edu.sg',
  'objectmail.com',
  'obobbo.com',
  'oneoffemail.com',
  'onewaymail.com',
  'online.ms',
  'oopi.org',
  'opayq.com',
  'ordinaryamerican.net',
  'otherinbox.com',
  'ourklips.com',
  'outlawspam.com',
  'ovpn.to',
  'owlpic.com',
  'pancakemail.com',
  'pjjkp.com',
  'plexolan.de',
  'politikerclub.de',
  'poofy.org',
  'pookmail.com',
  'privacy.net',
  'privatdemail.net',
  'privy-mail.com',
  'privymail.de',
  'proxymail.eu',
  'prtnx.com',
  'punkass.com',
  'putthisinyourspamdatabase.com',
  'pwrby.com',
  'qisdo.com',
  'qisoa.com',
  'quickinbox.com',
  'quickmail.nl',
  'rcpt.at',
  're-gister.com',
  'reallymymail.com',
  'realtyalerts.ca',
  'receiveee.chickenkiller.com',
  'receiveee.com',
  'recursor.net',
  'regbypass.com',
  'regbypass.comsafe-mail.net',
  'rejectmail.com',
  'remail.ga',
  'remail.cf',
  'remail.ml',
  'rhyta.com',
  'rklips.com',
  'rmqkr.net',
  'royal.net',
  'rppkn.com',
  'rtrtr.com',
  's0ny.net',
  'safe-mail.net',
  'safersignup.de',
  'safetymail.info',
  'safetypost.de',
  'sandelf.de',
  'saynotospams.com',
  'selfdestructingmail.com',
  'sendspamhere.com',
  'shiftmail.com',
  'shitmail.me',
  'shortmail.net',
  'shut.name',
  'shut.ws',
  'sibmail.com',
  'sinnlos-mail.de',
  'siteposter.net',
  'skeefmail.com',
  'slaskpost.se',
  'slopsbox.com',
  'slowslow.de',
  'smashmail.de',
  'smellfear.com',
  'snakemail.com',
  'sneakemail.com',
  'sneakmail.de',
  'snkmail.com',
  'sofimail.com',
  'sofort-mail.de',
  'sogetthis.com',
  'soodonims.com',
  'spam.la',
  'spam.su',
  'spamavert.com',
  'spambob.com',
  'spambob.net',
  'spambob.org',
  'spambog.com',
  'spambog.de',
  'spambog.net',
  'spambog.ru',
  'spambox.info',
  'spambox.irishspringrealty.com',
  'spambox.us',
  'spamcannon.com',
  'spamcannon.net',
  'spamcero.com',
  'spamcon.org',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamdecoy.net',
  'spameater.com',
  'spameater.org',
  'spamex.com',
  'spamfree.eu',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.info',
  'spamfree24.net',
  'spamhole.com',
  'spamify.com',
  'spaminator.de',
  'spamkill.info',
  'spaml.com',
  'spaml.de',
  'spammotel.com',
  'spamobox.com',
  'spamoff.de',
  'spamsalad.in',
  'spamslicer.com',
  'spamstack.net',
  'spamthis.co.uk',
  'spamthisplease.com',
  'spamtrail.com',
  'spamtroll.net',
  'speed.1s.fr',
  'spikio.com',
  'spoofmail.de',
  'squizzy.de',
  'ssoia.com',
  'startkeys.com',
  'stexsy.com',
  'stinkefinger.net',
  'stop-my-spam.cf',
  'stop-my-spam.com',
  'stop-my-spam.ga',
  'stop-my-spam.ml',
  'stop-my-spam.tk',
  'stuffmail.de',
  'super-auswahl.de',
  'supergreatmail.com',
  'supermailer.jp',
  'superrito.com',
  'superstachel.de',
  'suremail.info',
  'svk.jp',
  'tafmail.com',
  'taglead.com',
  'tagyourself.com',
  'talkinator.com',
  'tapchicuoihoi.com',
  'teewars.org',
  'teleosaurs.xyz',
  'tellos.xyz',
  'temp.emeraldwebmail.com',
  'temp.headstrong.de',
  'temp15qm.com',
  'tempail.com',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.co.za',
  'tempemail.com',
  'tempemail.net',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.co',
  'tempmail.de',
  'tempmail.eu',
  'tempmail.it',
  'tempmail.net',
  'tempmail.us',
  'tempmail.ws',
  'tempmail2.com',
  'tempmailaddress.com',
  'tempmaildemo.com',
  'tempmailer.com',
  'tempmailer.de',
  'tempomail.fr',
  'temporarily.de',
  'temporarioemail.com.br',
  'temporaryemail.net',
  'temporaryemail.us',
  'temporaryforwarding.com',
  'temporaryinbox.com',
  'temporarymailaddress.com',
  'tempthe.net',
  'thankyou2010.com',
  'thanksthanks.net',
  'thc.st',
  'thecloudindex.com',
  'thelimestones.com',
  'thisisnotmyrealemail.com',
  'thismail.net',
  'throam.com',
  'throwawayemailaddress.com',
  'tilien.com',
  'tittbit.in',
  'tmailinator.com',
  'tmail.ws',
  'toiea.com',
  'tokenmail.de',
  'toomail.biz',
  'topranklist.de',
  'tradermail.info',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.cf',
  'trash-mail.com',
  'trash-mail.de',
  'trash-mail.ga',
  'trash-mail.gq',
  'trash-mail.ml',
  'trash-mail.tk',
  'trash2009.com',
  'trash2010.com',
  'trash2011.com',
  'trashbox.eu',
  'trashdevil.com',
  'trashdevil.de',
  'trashemail.de',
  'trashemailaddress.com',
  'trashinbox.com',
  'trashmail.at',
  'trashmail.de',
  'trashmail.ws',
  'trashmailer.com',
  'trashymail.net',
  'trbvm.com',
  'trickmail.net',
  'trillianpro.com',
  'tryalert.com',
  'turboprinz.de',
  'twinmail.de',
  'twoweirdtricks.com',
  'tyldd.com',
  'ubismail.net',
  'uggsrock.com',
  'umail.net',
  'upliftnow.com',
  'uplipht.com',
  'uroid.com',
  'us.af',
  'valemail.net',
  'venompen.com',
  'veryrealemail.com',
  'viditag.com',
  'viralplays.com',
  'vpn.st',
  'vsimcard.com',
  'vubby.com',
  'wasteland.rfc822.org',
  'webemail.me',
  'webm4il.info',
  'webuser.in',
  'wegwerfadresse.de',
  'wegwerfemail.com',
  'wegwerfemail.de',
  'wegwerfmail.de',
  'wegwerfmail.info',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wetrainbayarea.com',
  'wetrainbayarea.org',
  'wh4f.org',
  'whatiaas.com',
  'whatpaas.com',
  'whopy.com',
  'whtjddn.33mail.com',
  'whyspam.me',
  'willhackforfood.biz',
  'willselfdestruct.com',
  'winemaven.info',
  'wolfsmail.tk',
  'wollan.info',
  'writeme.com',
  'wronghead.com',
  'wuzup.net',
  'wuzupmail.net',
  'wwwnew.eu',
  'x.ip6.li',
  'xagloo.com',
  'xemaps.com',
  'xents.com',
  'xmaily.com',
  'xoxy.net',
  'yapped.net',
  'yep.it',
  'yogamaven.com',
  'yuurok.com',
  'z1p.biz',
  'za.com',
  'zehnminuten.de',
  'zehnminutenmail.de',
  'zetmail.com',
  'zippymail.info',
  'zoaxe.com',
  'zoemail.com',
  'zoemail.net',
  'zoemail.org',
  'zomg.info',
  'zxcv.com',
  'zxcvbnm.com',
  'zzz.com',
];

/**
 * Checks if an email address is from a known disposable/temporary email domain
 * @param email - The email address to check
 * @returns true if the email is from a disposable domain, false otherwise
 */
export function isDisposableEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const domain = email.toLowerCase().split('@')[1];
  
  if (!domain) {
    return false;
  }

  return BLOCKED_EMAIL_DOMAINS.includes(domain);
}
